import { configure } from "nprogress"

const interFace = {

        //整车SVHC分析
        vehicleSVHCAnalysis: {
            list: '/scip/SvhcInfo/bomModPage',
            createBom: '/scip/SvhcInfo/scipBomCreate',
        },
        SVHCModelBOMInfo: {
            SVHCAnalysis: '/scip/SvhcInfo/analysisSvhcSubstance',
            SVHCExport: '/scip/SvhcInfo/svhcAnalysisSubstanceExport'
        },
        //SCIP通报
        SCIPFill: {
            login: '/login',
            saveRefNode: '/scip/scipIuclid6Article/saveRefNode',
            deleteRefTreeNode: '/scip/scipIuclid6Article/deleteRefTreeNode',
            SCIPSubstanceFill: '/scip/scipIuclid6Article',
            scipIuclid6ArticleInf: '/scip/scipIuclid6Article',
            createExport: '/scip/scipIuclid6Dossier/export/i6z/', //uuid
            checkTaskStatus: '/scip/scipIuclid6Dossier/job/status/', //uuid
            workSpaceDetail: '/scip/scipIuclid6WorkingContext/', //id
            editWorkspace: '/scip/scipIuclid6WorkingContext',
            dossierDetail: '/scip/scipIuclid6Dossier/header/', //id
            createDossier: '/scip/scipIuclid6Dossier/',
            getValidateData: '/scip/scipIuclid6Dossier/validateDossier',
            bomQuery: '/scipBom/info/bomQuery',
            upload: '/scip/scipIuclid6Article/upload',
            getSubstance: '/scip/scipIuclid6Article/getReferenceSubstance',
            getReferebcedByQuery: '/scip/scipIuclid6Article/getReferebcedByQuery',
            getWorkspace: '/scip/scipIuclid6WorkingContext/',
    
            downLoadPictures: '/scip/scipIuclid6Article/download',
            getPictures: '/scip/scipIuclid6Article/getAttachmentInfo'
        },
    //规则管理
    reviewTheRules: { //审核规则
        list: '/rule/auditRules/page',
        edit: '/rule/auditRules/saveOrUpdate',
        //规则管理
        rule:{//规则
            list: '/rule/auditRules/page',
            edit: '/rule/auditRules/saveOrUpdate',
        },//应用选项
        Application:{
            camds:{
                list: '/rule/auditAppcode/camdsPage',
                edit: '/rule/auditAppcode/camdsUpdate',
            },
            imds:{
                list: '/rule/auditAppcode/imdsPage',
                edit: '/rule/auditAppcode/imdsUpdate',
            },
        }
    },
    regulatoryInformation: { //法规信息
        list: '/rule/msgLawInfo/page',
        edit: '/rule/msgLawInfo/saveOrUpdate',
        delete: '/rule/msgLawInfo/delete'
    },
    banner: { //公告信息
        list: '/announcementInfo/page',
        add: '',
        edit: '/announcementInfo/saveOrUpdate',
        delete: '/announcementInfo/delete',
    },
    regulatoryInformationInfo: { //物质明细
        list: '/rule/msgLawList/page',
        edit: '/rule/msgLawList/saveOrUpdate',
        delete: '/rule/msgLawList/delete',
        add: '/rule/msgLawList/saveBatch',
        regulatoryInformationInfoAdd: { //物质明细新增列表
            getSubType: '/rule/msgLawList/getSubType',
            list: '/rule/msgLawList/sub/add',
            edit: '/rule/msgLawList/saveOrUpdate',
            import: '/rule/msgLawList/import/', ///{infoId}
        }
    },

    // bom树结构
    BomUrl: {
        // SCIPTreeRoot: '/scip/scipIuclid6Article/getParentNodeByModId',
        SCIPTreeRoot: '/scip/scipIuclid6Article/getParentNodeByModId',
        SCIPTreeLeaves: '/scip/scipIuclid6Article/getChildNodeByCsid',
        treeRoot: '/bom/info/getParentNodeByModCsid',
        treeRootByCkid: '/bom/info/getParentBomNodeByCkid',
        treeLeaves: '/bom/info/getBomChildByCkid',
        addLeaves: '/bom/info/addBom',
        deleteLeaves: '/bom/info/deleteBom/',
        editLeaves: '/bom/info/updateBom',
        linkLeaves: '/bom/info/articulatedMdsToTree',
        bomQuery: '/bom/info/bomQuery',
        fill: '/model/highRiskMark/saveOrUpdate', //填报
        unFill: '/model/highRiskMark/delete', //取消填报
        getHighRiskComponentInfoEO: '/model/highRiskMark/getHighRiskComponentInfoEO', //返回零件通用名称
        getAnaResRuleEOs: '/analysis/anaResMark/getAnaResRuleEOs', //返回有害标注信息
        identificationAdd: '/analysis/anaResMark/saveOrUpdate', //有害标注新增
        identificationDelete: '/analysis/anaResMark/delete', //有害标注新增
        getMatrialInfo: '/analysis/anaRrrMark/getMatrialInfo', //获取材料范围和材料回收利用阶段信息
        getRrrMarkInfo: '/analysis/anaRrrMark/getRrrMarkInfo', //获取零部件回收利用阶段信息
        getSubRrrInfo: '/analysis/anaRrrMark/getSubRrrInfo', //获取子阶段信息 mp1 mp2
        mark: '/analysis/anaRrrMark/mark', //根据车型或零部件标注
        deleteMark: '/analysis/anaRrrMark/deleteMark', //根据车型或零部件取消标注
        getTechnicalinfo: '/analysis/anaRrrMark/getTechnicalinfo', //获取材料mtr已验证技术
    },
    ImdsBomUrl: {
        treeRoot: '/imdsBom/info/getParentBomNodeByCkid', //通过ckid信息bom的根节点信息  get
        treeRootByCkid: '/imdsBom/info/getParentBomNodeByCkid', //通过ckid信息获取下面的直接子集  get
        treeLeaves: '/imdsBom/info/getBomChildByCkid', //根据节点id获取节点详情  get
        bomQuery: '/imdsBom/info/bomQuery', // bom节点查询  get
    },
    rbsAnalysis: { //禁限用物质分析
        getRule: '/rule/msgLawInfo/list',
        analysisSubstance: '/analysis/prohibitSubstance/analysisSubstance',
        export: '/analysis/prohibitSubstance/analysisSubstanceExport',
    },
    taggingRules: { //标注规则
        list: '/rule/anaMaterialMarkRule/page',
        edit: '/rule/anaMaterialMarkRule/saveOrUpdate',
        delete: '/rule/anaMaterialMarkRule/delete',
        getMaterialtypeEO: '/rule/anaMaterialMarkRule/getMaterialtypeEO', //材料分类
        getMaterialtypeEOByAdd: '/rule/anaMaterialMarkRule/getMaterialtypeEOByAdd', //可新增材料分类
        getTechNum: '/rule/anaMaterialMarkRule/getTechNum', //已验证技术
        getScope: '/rule/anaMaterialMarkRule/getScope', //材料范围
        getAnaMatScopeEOsByTypeIdAndScope: '/rule/anaMaterialMarkRule/getAnaMatScopeEOsByTypeIdAndScope' //返回标注阶段
    },
    taggingRulesInfo: { //材料标识
        list: '/rule/anaMatFlagscope/page',
        edit: '/rule/anaMatFlagscope/saveOrUpdate',
        // delete:'/rule/anaMaterialMarkRule/delete',
    },
    RrrExport: {
        chooseComponent: '/analysis/anaRrrMark/export/chooseComponent', //表格查询
        exportVehicleRrr: '/analysis/anaRrrMark/export/exportVehicleRrr', //两率报告
        exportMadeVehicleRrr: '/analysis/anaRrrMark/export/exportMadeVehicleRrr', //自定义两率报告
        exportParamReport: '/analysis/anaRrrMark/export/exportParamReport', //导出参数报告
        EU_ParamReport: '/analysis/anaRrrMark/export/exportEuVehicleRrr', //欧盟导出参数报告
    },
    rbsExemptionAnalysisInfo: { //豁免分析
        rbsExemptionAnalysisInfo: '/analysis/anaResMark/page',
        export: '/analysis/anaResMark/export/',
    },
    RRRlabelingAndScreening: { //RRR筛选
        list: '/analysis/anaRrrChoose/queryRrr',
        queryAllMatScope: '/analysis/anaRrrChoose/queryAllMatScope', //查询全部材料范围
        queryAllMatType: '/analysis/anaRrrChoose/queryAllMatType', //查询全部材料类别
        queryAllTech: '/analysis/anaRrrChoose/queryAllTech', //查询全部验证技术
        modList: '/model/modInfo/modList', //查询全部车型
        getSubRrrInfo: '/analysis/anaRrrMark/getSubRrrInfo', //mp类别
        getMatrialInfo: '/analysis/anaRrrMark/getMatrialInfo', //获取材料范围和材料回收利用阶段信息
        getRrrMarkInfo: '/analysis/anaRrrMark/getRrrMarkInfo', //获取零部件回收利用阶段信息
        export:'/analysis/anaRrrChoose/exportAnaRrrChoose',
        queryMod: {
            list: '/analysis/anaRrrChoose/queryMod'
        } //查询这条信息的全部车型
    },
    // 数据管理
    camdsDataAdmin: { //本地数据管理CAMDS
        list: '/data/localDataManage/page',
        export: '/data/localDataManage/export',
        edit: '/data/localDataManage/setUp',
        delete: '/data/localDataManage/delete',
        bomExport: '/bom/info/exportBom/new/',
        bomExportCSV: '/bom/info/exportCsvBom/',
        copy: '/data/localDataManage/copyLocalData', //复制表单
        citationAnalysis: '/data/localDataManage/page/shit',
        analysis: '/data/localDataManage/page/selectParentCamdsDataEO',
    },
    imdsDataAdmin: { //本地数据管理CAMDS
        list: '/data/localDataManage/page',
        export: '/data/localImdsDataManage/export',
        edit: '/data/localImdsDataManage/setUp',
        delete: '/data/localImdsDataManage/delete',
        info: '/imdsBom/info/getNodeDetail/',
        CitationAnalysisExport:'/data/localDataManage/exportParentCamdsDataEO',
    },
    localDataAdmin: {
        list: '/data/localDataManage/pageLocalData',
        addParts: '/data/local/component/addLocalComponentByOne', //新增零件
        addBlank: '/data/local/semicomponent/addLocalSemicomponent', //新增半成品
        addMatter: '/data/local/material/addSubstance', //新增物质
        addMaterial: '/data/local/material/addMaterialByOne', //新增材料
        link: '/data/local/material/articulatedDataToTree', //新增组件,挂接材料
        getAllMaterialType: '/data/camds/materialType/getAllMaterialType', //材料分类
        deleteNode: '/data/local/material/deleteCamdsBom/', //材料分类
        changeNode: '/data/local/component/changeNode', //置换
        makeNodesBecomesComponentized: '/data/local/component/makeNodesBecomesComponentized', //转换组件
        queryTree: '/data/local/component/queryTree', //获取零件分类
        deptAndUserList: '/data/deptUser/deptAndUserList', //部门联系人信息

        updateComponent: '/data/local/component/updateComponent', //修改零件信息
        semicomponent: '/data/local/semicomponent/updateSemicomponent', //修改半成品信息
        updateMaterial: '/data/local/material/updateMaterial', //修改材料信息
        updateCamdsSubstance: '/data/substance/updateCamdsSubstance', //修改物质
        info: '/data/camdsBom/info/getNodeDetail/', //节点详情
        substance: '/data/substance/page', //新增物质搜索
        afreshCheck: '/data/local/component/afreshCheck', //新增校验
        matstandard: '/data/matstandard/list', //获取引用标准
        insideRelease: '/data/local/component/insideRelease', //获取内部发布
        selectCmatFlagRefStd: '/data/local/material/selectCoption', //材料分类下拉
        getOptionname: '/data/local/component/getOptionname', //应用选项
        uploadCAMDS:'/webservice/uploadMds',//上传camds
    },
    PartsChange: { //车型变更
        list: '/model/componentChangeInfo/page', //主表page
        partList: '/model/componentChangeInfo/com', //查询车型可变更零件
        add: '/model/componentChangeInfo/saveOrUpdate', //新增接口
        delete: '/model/componentChangeInfo/delete', //删除接口
        export: '/model/componentChangeInfo/export', //导出接口
    },
    PartsExtend: { //车型扩展
        list: '/model/componentRecord/page', //主表
        export: '/model/componentRecord/export', //导出
        add: '/model/componentRecord/saveOrUpdate', //新增
        delete: '/model/componentRecord/delete', //删除
    },
    WelcomePage: { //首页
        fileList: '/analysis/homepage/fileList', //文件管理
        todoList: '/analysis/homepage/todoList', //代办管理
        bannerList: '/announcementInfo/list', //公告管理
        updateUserTodoReport: '/analysis/homepage/updateUserTodoReport', //删除代办
    },
    messageReminding: { //消息提醒
        list: '/message/dingding/page', //文件管理

    },
    camdsDataSynchronism: { //本地数据管理CAMDS
        list: '/webservice/getMdsList',
        dolnLoadData: '/webservice/downLoadMds',
        dolnLoadDataSupply: '/webservice/downLoadMdsSupply',
        analysisSubstance: '/analysis/prohibitSubstance/analysisSubstance',
        materialAnalysisResults: {
            list: '/analysis/prohibitSubstance/queryListByCkid', //,
            export: '/analysis/prohibitSubstance/anaQueryListExport',
        },
        anaQueryList: {
            list: '/analysis/prohibitSubstance/anaQueryList',
        },

        login: {
            list: '/data/camdsSyncUserlog/page'
        },
        listCAMDS: '/system/configCamdsAccount/list', //CAMDS账号配置
        downLodaLog: {
            list: '/data/camdsMdsErrorInfo/page',
            export: '/data/camdsMdsErrorInfo/export',
        },
        exportErrMsg: '/webservice/exportErrMsg' //导出下载错误信息

    },
    imdsDataSynchronism: { //本地数据管理iMDS
        list: '/data/imdsDownload/page', //主表
        downloadMds: '/data/imdsDownload/downloadMds', //重新下载
        downLodaLog: {
            list: '/data/imdsMdsErrorInfo/page',
            export: '/data/imdsMdsErrorInfo/export',
        },
        anaQueryList: {
            list: '/analysis/prohibitSubstance/anaQueryList',
        },
        materialAnalysisResults: {
            list: '/analysis/prohibitSubstance/queryListByCkid', //,
            export: '/analysis/prohibitSubstance/anaQueryListExport',
        },
    },

    componentRRRCalculation: { //RRR零件标注
        list: '/analysis/anaRrrMark/componentList', //主表
        autoMark: '/analysis/anaRrrMark/autoMark', //自动标注
        unAutoMark: '/analysis/anaRrrMark/clearMark', //清楚全部标注
        check: '/analysis/anaRrrMark/check', //清楚全部标注
        queryMarkInfoByCkid: 'api/analysis/anaRrrMark/queryMarkInfoByCkid', //清楚全部标注
        locak: '/analysis/anaRrrMark/lockMark', //锁定
        calculationInfo: '/analysis/anaRrrMark/calculationInfo', //计算
        getRedisCalculationInfo: '/analysis/anaRrrMark/getRedisCalculationInfo', //历史计算结果
        getIsLock: '/analysis/anaRrrMark/getIsLock' //获取当前数据还是否锁定
    },
    camdsEssentialData: { //基础数据管理
        list: '/webservice/syncInfo/page',
        downloadAppoption: '/webservice/downloadAppoption', //下载应用选项
        downloadEntinfo: '/webservice/downloadEntinfo', //下载企业信息
        downloadMaterial: '/webservice/downloadMaterial', //下载标准材料
        downloadMaterialtype: '/webservice/downloadMaterialtype', //下载材料分类
        downloadMatflag: '/webservice/downloadMatflag', //下载聚合物标识
        downloadMatstandard: '/webservice/downloadMatstandard', //下载引用标准
        downloadSubstance: '/webservice/downloadSubstance', //下载基本物质
    },
    imdsEssentialData: { //基础数据管理
        list: '/data/imdsSyncInfo/page',
        syncImdsAppcode: '/data/imdsData/syncImdsAppcode', //下载应用选项
        syncImdsMaterialType: '/data/imdsData/syncImdsMaterialType', //下载材料分类
        syncImdsSubstance: '/data/imdsData/syncImdsSubstance', //下载基本物质
        syncImdsSupplierInfo: '/data/imdsData/syncImdsSupplierInfo', //下载企业信息
        downFailData: '/data/imdsData2/downFailData', //失败数据下载
    },
    auditDistribute: { //审核分发
        add: '/data/camdsDistribution/AddOneDistribute',
        list: '/data/camdsDistribution/page',
        edit: '/data/camdsDistribution/saveOrUpdate',
        delete: '/data/camdsDistribution/delete',
        import: '/data/camdsDistribution/importData', ///{infoId}
        info: '/data/camdsDistribution/detail', ///{infoId}
    },
    auditInformation: { //审核信息
        list: '/data/audit/page',
        audit: '/data/audit/audit',
        getRefuseReasonEnum: '/data/audit/getRefuseReasonEnum', //获取拒绝原因枚举以便前台进行展示
        auditInformationInfo: { //审核记录
            list: '/data/audit/getAuditLog'
        },
        export: '/data/audit/export',
        afreshCheck: '/webservice/afreshCheck',
    },
    ImdsAuditInformation: { //审核信息
        list: '/data/imdsAudit/page',
        audit: '/data/imdsAudit/audit',
        getRefuseReasonEnum: '/data/imdsAudit/getRefuseReasonEnum', //获取拒绝原因枚举以便前台进行展示
        auditInformationInfo: { //审核记录
            list: '/data/imdsAudit/getAuditLog'
        },
        export: '/data/imdsAudit/export',
        afreshCheck: '/data/imdsMdsErrorInfo/afreshCheck', //重新校验
        syncStatus: '/data/imdsAudit/syncStatus',
    },
    ModelBOMInfo: { //车型BOM信息
        list: '/bom/info/getNodeDetail/',
        camdsBomMatchingInfo: '/model/camdsBomMatchingInfo/page',
        matching: '/bom/info/matching',
        singleMatching: '/bom/info/singleMatching',
        export: '/bom/info/exportBom/',
        exportResult: '/model/camdsBomMatchingInfo/exportResult/',
        calculatedMass: '/analysis/anaRrrMark/getCmeaWeightPerItem/',
        rootTabelHerade:'/system/configBomImportField/list',
        updataRootTabelHerade:'/system/configBomImportField/update',
    },
    DangerInfo: { //高危清单详细
        export: '/model/highRiskMark/export/', //数据导出
        highRiskMarkSubmit: '/model/highRiskMark/saveOrUpdateBatch', //数据导出
        highRiskMarkList: '/model/highRiskMark/pageNew' //'/model/highRiskMark/page',//填报信息
    },
    // 系统管理
    departmentInfo: { //部门信息
        list: '/system/deptInfo/page',
        edit: '/system/deptInfo/saveOrUpdate',
        delete: '/system/deptInfo/delete',
        getDeptTree: "/api/system/deptInfo/getDeptTree"
    },
    userManage: { //用户信息
        list: "/api/system/userInfo/page",
        add: '/system/userInfo/add',
        edit: '/system/userInfo/update',
        delete: '/system/userInfo/delete',
        changePaw: '/system/userInfo/updatePassword',
        upload: '/system/userInfo/importUser',
        download: "/api/system/userInfo/exportUserList",
        downloaduser: '/system/userInfo/downloadUserTemplate',
        pwdRreset: '/system/userInfo/resetPassword',
        getModIds: '/system/userInfo/getModIds',
    },
    RoleManage: { //角色信息
        list: '/system/roleInfo/page',
        info: '/system/roleInfo/list',
        edit: '/system/roleInfo/saveOrUpdate',
        delete: '/system/roleInfo/delete',
    },
    LogManage: { //日志信息
        list: '/system/logInfo/page',
        edit: '/system/roleInfo/saveOrUpdate',
        delete: '/system/roleInfo/delete',
        export:'/system/logInfo/exportLogInfo',//导出日志
    },
    ConfigurationManage: { //配置信息
        listPaw: '/system/config/getDefaultPassword', //新增账号密码配置
        listhelp: '/system/config/getHelp', //帮助提示内容配置
        listCAMDS: '/system/configCamdsAccount/list', //CAMDS账号配置
        listIMDS: '/system/configImdsAccount/list', //IMDS账号配置
        edit: '/system/roleInfo/saveOrUpdate',
        delete: '/system/roleInfo/delete',
    },
    ModelInformation: { //车型信息
        select: '/model/modInfo/list',
        list: '/model/modInfo/page',
        edit: '/model/modInfo/saveOrUpdate',
        delete: '/model/modInfo/delete',
        copy: '/model/modInfo/copyModel',
        modelType: '/model/modInfo/getType',
        cqcfill: '/data/modeFillInfo/getModeDataByMoId/',
        cqcsubmit: '/data/modeFillInfo/saveOrUpdate',
    },
    DangerList: { //高危分析
        list: '/model/modInfo/analysisModPage', //主表
    },
    rbsAnalysisList: { //禁限用物质分析
        list: '/model/modInfo/analysisModPage',
    },
    rbsExemptionAnalysisList: { //禁限用物质豁免分析
        list: '/model/modInfo/analysisModPage',
    },
    ModelBOMList: { //车型BOM信息
        // list: '/model/modInfo/analysisModPage',
        list: '/model/modInfo/bomModPage',
        edit: '/model/modInfo/saveOrUpdate',
        delete: '/bom/info/delete',
        lock: '/bom/info/updateStatus',
        import: '/bom/info/importBom'
    },
    materialAnalysis: { //整车材料分析
        list: '/model/modInfo/analysisModPage',
        Material: "/api/analysis/carMaterialDetail", //整车材料明细
        deviation: '/analysis/deviationAnalysis', //整车偏差分析
        materialDetails: '/analysis/materialsGroup', //材料分类
    },
    fileManagement: { //文件管理模块
        sysFileManagement: { //系统管理模块
            uploadFile: '/message/fileInfo/upload', //上传文件接口
            add: '/message/fileInfo/saveOrUpdate', //新增文件接口
            delete: '/message/fileInfo/delete', //删除数据
            export: '/message/fileInfo/batch/export', //下載数据
            list: '/message/fileInfo/page', //数据列表

        },
         carTypeFileManagement:{//车型管理模块
            uploadFile:'/message/mod/fileInfo/upload',//上传文件接口
            add:'/message/mod/fileInfo/saveOrUpdate',//新增文件接口
            delete:'/message/mod/fileInfo/delete',//删除数据
            export:'/message/mod/fileInfo/batch/export',//下載数据
            list:'/message/mod/fileInfo/mod/page',//数据列表

        },
    },
    reportToManagement: { //报告管理
        list: '/analysis/reportInfo/page', //主表list
        modelInfo: '/model/modInfo/info/', //车型信息
        delete: '/analysis/reportInfo/delete', //删除报告
        export: '/analysis/reportInfo/batch/export' //删除报告
    },
    CQC: { //cqc填报
        list: '/data/modeFillInfo/page',
        delete: '/data/modeFillInfo/delete',
        copy: '/data/modeFillInfo/copyModeFillInfo',
        import: '/bom/info/importCQCBom',
        Matching: '/bom/info/cqcMatching/',
        addLeaves: '/bom/info/addCqcBom',
        editLeaves: '/bom/info/updateCqcBom',
        info: '/bom/info/getNodeDetail/',
        exportResult: '/model/modInfo/exportCQC/',
        chack: '/model/camdsBomMatchingInfo/checkMatchingInfo/',
        linkLeaves: '/bom/info/cqcArticulatedMdsToTree',
        deleteLeaves: '/bom/info/cqcDeleteBom/',
        uplodaResult:'/model/modInfo/cqcVehicleUpload/'
    }
}
export default interFace